export const getExtension = (path: string): string => {
  const withoutQuery = path.split('?')[0];
  return withoutQuery.split('.').pop() as string;
};